<template>
    <div class="add_student">
        <div id="module_add_student" @click="closeModule()" class="add_student_block" v-clickOutside="() => closeAddStudent()" >
            <div class="add_student_header">
                <div class="title">
                    Добавить ученика  
                </div>
                <div class="svg" @click="closeAddStudent()">
                    <svg width="24" height="24" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M14.3751 4.1665L9.99951 8.5415L5.62489 4.1665L4.16669 5.62484L8.5413 9.99984L4.16669 14.3748L5.62489 15.8332L9.99951 11.4582L14.3751 15.8332L15.8334 14.3748L11.4587 9.99984L15.8334 5.62484L14.3751 4.1665Z" fill="#ABABB2"/>
                    </svg>
                </div>
            </div>
            <div class="block_add_student">
                <div class="add_student_main_info stroke1">
                    <div class="block" id="block1">
                        <div class="title_block">
                            Период оплаты
                        </div>
                        <div class="period" >
                            <div class="item item_height_student">
                                <div class="item_block"  @click="openPer()">
                                    <div class="block_item" :class="(selectPeriod !== 'Выберите период')?('color_black'):('active')">
                                        {{selectPeriod}}
                                    </div>
                                    <div class="block_item_svg">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.35353 10.543L12.2197 7.67683L12.5731 8.03023L8.99998 11.6034L5.42683 8.03023L5.78023 7.67683L8.64642 10.543L8.99998 10.8966L9.35353 10.543Z" fill="#C0CADC" stroke="#C0CADC"/>
                                        </svg>
                                    </div>
                                </div>
                                <transition name="fade">
                                    <div class="notifications error" v-if="notifications.period !== ''">
                                        {{notifications.period}}
                                        <div class="notifications_square">
                                                            
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <transition name="fade">
                                <div class="block_item_module" v-show="perCheck === true" >
                                    <div class="block_item_module_text" v-for="(per, j) in period" :key="j" @click="selectPerFunc(per)">
                                        {{per.text}}
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title_block">
                            Тариф
                        </div>
                        <div class="rate" >
                            <div class="item item_height_student">
                                <div class="item_block"  @click="openRateDeduct()">
                                    <div class="block_item" :class="(selectRate !== 'Выберите тариф')?('color_black'):('active')">
                                        {{selectRate}}
                                    </div>
                                    <div class="block_item_svg">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.35353 10.543L12.2197 7.67683L12.5731 8.03023L8.99998 11.6034L5.42683 8.03023L5.78023 7.67683L8.64642 10.543L8.99998 10.8966L9.35353 10.543Z" fill="#C0CADC" stroke="#C0CADC"/>
                                        </svg>
                                    </div>
                                </div>
                                <transition name="fade">
                                    <div class="notifications error" v-if="notifications.selectRate !== ''">
                                        {{notifications.selectRate}}
                                        <div class="notifications_square">
                                                            
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <transition name="fade">
                                <div class="block_item_module" v-show="rateCheck === true" >
                                    <div class="block_item_module_text" v-for="(rat, j) in rate" :key="j" @click="selectRateFunc(rat)">
                                        {{rat.text}}
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="block">
                        <div class="title_block">
                            Месяцев
                        </div>
                        <div class="month" >
                            <div class="item item_height_student">
                                <div class="item_block"  @click="openMonth()">
                                    <div class="block_item" :class="(selectMonth !== '0')?('color_black'):('active')">
                                        {{selectMonth}}
                                    </div>
                                    <div class="block_item_svg">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.35353 10.543L12.2197 7.67683L12.5731 8.03023L8.99998 11.6034L5.42683 8.03023L5.78023 7.67683L8.64642 10.543L8.99998 10.8966L9.35353 10.543Z" fill="#C0CADC" stroke="#C0CADC"/>
                                        </svg>
                                    </div>
                                </div>
                                <transition name="fade">
                                    <div class="notifications error" v-if="notifications.selectMonth !== ''">
                                        {{notifications.selectMonth}}
                                        <div class="notifications_square">
                                                            
                                        </div>
                                    </div>
                                </transition>
                            </div>
                            <transition name="fade">
                                <div class="block_item_module" v-show="monthCheck === true" >
                                    <div class="block_item_module_text" v-for="(month, j) in months" :key="j" @click="selectMonthFunc(month)">
                                        {{month.text}}
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="block" >
                        <div class="title_block">
                            Промокод
                        </div>
                        <div class="cod" >
                            <div class="item item_height_student" :class="(showCodes === false)?('disabled'):('active')">
                                <div class="item_block"  @click="openCod()">
                                    <div class="block_item" :class="(selectCod !== 'Выберите промокод')?('color_black'):('')">
                                        {{selectCod}}
                                    </div>
                                    <div class="block_item_svg">
                                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.35353 10.543L12.2197 7.67683L12.5731 8.03023L8.99998 11.6034L5.42683 8.03023L5.78023 7.67683L8.64642 10.543L8.99998 10.8966L9.35353 10.543Z" fill="#C0CADC" stroke="#C0CADC"/>
                                        </svg>
                                    </div>
                                    <transition name="fade">
                                        <div class="notifications error" v-if="notifications.selectCod !== ''">
                                            {{notifications.selectCod}}
                                            <div class="notifications_square">
                                                                
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                            <transition name="fade">
                                <div class="block_item_module" v-show="codCheck === true">
                                    <div class="block_item_module_text" v-for="(cod, j) in arrcodes" :key="j" @click="selectCodFunc(cod)">
                                        {{cod.text}}
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    
                </div>
                <div class="add_student_main_info stroke2">
                    <div class="inputBlock">
                        <div class="inputBlock_title">
                            Ссылка на ВКонтакте
                        </div>
                        <div class="inputBlock_input"
                            :class="(notifications.vkLink !== '')?('errorNotifications'):('')"
                        >
                            <input type="text" 
                                    id="vkLinl" 
                                    placeholder="Вставьте ссылку на ВКонтакте" 
                                    v-model="vkLink" 
                            >
                            <transition name="fade">
                                <div class="notifications error" v-if="notifications.vkLink !== ''">
                                    {{notifications.vkLink}}
                                    <div class="notifications_square">
                                                        
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="inputBlock">
                        <div class="inputBlock_title">
                            Почта
                        </div>
                        <div class="inputBlock_input"
                            :class="(notifications.email !== '')?('errorNotifications'):('')"
                        >
                            <input type="text" 
                                    id="email" 
                                    placeholder="Введите почту" 
                                    v-model="email" 
                            >
                            <transition name="fade">
                                <div class="notifications error" v-if="notifications.email !== ''">
                                    {{notifications.email}}
                                    <div class="notifications_square">
                                                        
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="inputBlock">
                        <div class="inputBlock_title">
                            Стоимость
                        </div>
                        <div class="inputBlock_input"
                            :class="(notifications.price !== '')?('errorNotifications'):('')"
                        >
                            <input type="text" 
                                    id="price" 
                                    placeholder="Тут появиться стоимость" 
                                    v-model="mount.price" 
                                    class="price"
                                    disabled
                            >
                            <transition name="fade">
                                <div class="notifications error" v-if="notifications.price !== ''">
                                    {{notifications.price}}
                                    <div class="notifications_square">
                                                        
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                    <div class="inputBlock">
                        <div class="inputBlock_title">
                            Фактическая оплата
                        </div>
                        <div class="inputBlock_input"
                            :class="(notifications.payment !== '')?('errorNotifications'):('')"
                        >
                            <input type="text" 
                                    id="payment" 
                                    placeholder="Введите оплату" 
                                    v-model="payment" 
                                    @input="inputPayment()"
                            >
                            <transition name="fade">
                                <div class="notifications error" v-if="notifications.payment !== ''">
                                    {{notifications.payment}}
                                    <div class="notifications_square">
                                                        
                                    </div>
                                </div>
                            </transition>
                        </div>
                    </div>
                </div>
                <div class="add_student_button" >
                    <button class="button" @click="addStudent()">Добавить ученика</button>
                </div>
            </div>
            
           
        </div>
    </div>
</template>

<script>
import { send } from '../../fetchData'
    export default {
        name: 'addStudentModule', 
        props:{
            rate:{
                type: Array,
                default:[]
            },
            months:{
                type: Array,
                default:[]
            },
            period:{
                type: Array,
                default:[]
            },
            codes:{
                type: Array,
                default:[]
            },
            prices:{
                type: Array,
                default:[]
            }
        },
        data(){
            return{
                arrcodes: [],
                vkLink:'',
                email:'',
                price:'',
                payment:'',
                selectRate:'Выберите тариф',
                selectRateId:0,
                selectMonth:'0',
                selectMonthId:0,
                selectPeriod:'Выберите период',
                selectPeriodId:0,
                selectCod:'Выберите промокод',
                selectCodId:0,
                notifications:{
                    vkLink:'',
                    email:'',
                    selectRate:'',
                    selectMonth:'',
                    selectCod:'',
                    price:'',
                    period:'',
                    payment:''
                },
                rateCheck: false,
                enableRateCheck: false,
                monthCheck: false,
                enableMonthCheck: false,
                perCheck: false,
                anablePerCheck: false,
                codCheck: false,
                enableCodCheck: false,
                mount:{
                    period:null,
                    rate:0,
                    cod: 0,
                    month: 0,
                    price:null,
                    periodId:null,
                    codId: null
                },
                showCodes: false
            }
        },
        watch:{
            mount:{
                handler(newVal, oldVal) {
                    this.priceChange
                },
                deep: true,
            },
            selectMonth(newVal, oldVal){
                if(this.selectMonth === '1 месяц' || this.selectMonth === '4 месяц'){
                    this.arrcodes = []
                    if(this.selectMonth === '1 месяц'){ 
                        this.selectCod = 'Выберите промокод'
                        this.selectCodId = 0
                        this.mount.cod = 0
                        this.mount.codId = null
                        this.codes.forEach((item, i) =>{
                            if(item.is_one_month === true){
                                this.arrcodes.push(item)
                            }
                        })
                        if(this.arrcodes.length > 0){
                            this.showCodes = true
                        }
                    }else if(this.selectMonth === '4 месяц'){
                        this.selectCod = 'Выберите промокод'
                        this.selectCodId = 0
                        this.mount.cod = 0
                        this.mount.codId = null
                        this.codes.forEach((item, i) =>{
                            this.arrcodes.push(item)
                        })
                        this.showCodes = true
                    }
                    
                }else{
                    this.selectCod = 'Выберите промокод'
                    this.selectCodId = 0
                    this.mount.cod = 0
                    this.mount.codId = null
                    this.showCodes = false
                }
            }
        },
        methods: {
            addStudent(){
                let data = {
                    module:'md_add_pay',
                    period_id: this.mount.periodId,
                    type_id: this.mount.rate,
                    promo_id: this.mount.codId,
                    count_month: this.mount.month,
                    vk: this.vkLink,
                    email: this.email,
                    amounts: Number(this.payment)
                }
                send
                    .post("marathon.php", data) //
                    .then((response) =>{
                        console.log("Успех")
                        this.$emit("addStudent")
                    })
                    .catch((error) =>{
                        console.log(error.response.data)
                        if(error.response.data.error === 'vk_or_email_required'){
                            this.notifications.email = 'Введите почту'
                            this.notifications.vkLink = 'Введите ссылку Вконтакте'

                            setTimeout(() => {
                                this.notifications.email = ''
                                this.notifications.vkLink = ''
                            }, 1500)
                        }else if(error.response.data.error === 'error_fields'){

                            error.response.data.error_field.forEach((item, i)=>{
                                if(item === 'vk'){
                                    this.notifications.vkLink = 'Введите правильную ссылку Вконтакте'
                                }
                                if(item === 'email'){
                                    this.notifications.email = 'Введите правильную почту'
                                }
                                if(item === 'promo_id'){
                                    this.notifications.selectCod = 'Выберите правильный код'
                                }
                                if(item === 'count_month'){
                                    this.notifications.selectMonth = 'Выберите месяц'
                                }
                            })
                            if(this.selectPeriod === 'Выберите период'){
                                this.notifications.period = 'Выберите период'
                            }
                            if(this.selectRate === 'Выберите тариф'){
                                this.notifications.selectRate = 'Выберите тариф'
                            }
                            if(this.vkLink === '' && this.email === ''){
                                this.notifications.vkLink = 'Введите ссылку Вконтакте'
                                this.notifications.email = 'Введите почту'
                            }
                            if(this.payment === ''){
                                this.notifications.payment = 'Введите сумму'
                            }
                            
                            setTimeout(() => {
                                this.notifications.period = ''
                                this.notifications.selectRate = ''
                                this.notifications.selectCod = ''
                                this.notifications.selectMonth = ''
                                this.notifications.vkLink = ''
                                this.notifications.payment = ''
                                this.notifications.email = ''
                            }, 1500)
                        }else if(error.response.data.error === 'user_not_found'){
                            this.notifications.email = 'Такой юзер не найден'
                            this.notifications.vkLink = 'Такой юзер не найден'

                            setTimeout(() => {
                                this.notifications.email = ''
                                this.notifications.vkLink = ''
                                
                            }, 1500)
                        }else if(error.response.data.error === 'user_pay_is_set'){
                            if(this.email !== ''){
                                this.notifications.email = 'Этот юзер уже платил курс'
                            }
                            if(this.vkLink !== ''){
                                this.notifications.vkLink = 'Этот юзер уже платил курс'
                            }
                            if(this.payment === ''){
                                this.notifications.payment = 'Введите сумму'
                            }

                            setTimeout(() => {
                                this.notifications.email = ''
                                this.notifications.vkLink = ''
                            }, 1500)
                        }
                    })
            },
            closeAddStudent(){
                this.mount.period = null
                this.mount.rate = 0
                this.mount.cod = 0
                this.mount.month = 0
                this.mount.price = null
                this.mount.periodId = null
                this.mount.codId = null
                this.vkLink = ''
                this.email = ''
                this.price = ''
                this.payment = ''
                this.selectRate = 'Выберите тариф'
                this.selectRateId = 0
                this.selectMonth='0'
                this.selectMonthId=0
                this.selectPeriod='Выберите период'
                this.selectPeriodId=0
                this.selectCod='Выберите промокод'
                this.selectCodId=0
                this.rateCheck= false
                this.enableRateCheck= false
                this.monthCheck= false
                this.enableMonthCheck= false
                this.perCheck= false
                this.anablePerCheck= false
                this.codCheck= false
                this.enableCodCheck= false
                this.showCodes= false

                
                this.$emit("close")
            },
            inputPayment(){
                this.payment = this.payment.replace(/\D/, '')
            },
            openPer(){
                this.perCheck = true
                setTimeout(() =>{
                    this.anablePerCheck = true
                }, 100)
            },
            openCod(){
                console.log(this.codes)
                if(this.showCodes === true){
                    this.codCheck = true
                    setTimeout(() => {
                        this.enableCodCheck = true
                    }, 100)
                }
                
                
            },
             openRateDeduct(){
                 console.log(this.rate)
                this.rateCheck = true;

                setTimeout(() => {
                    this.enableRateCheck = true
                }, 100)
            },
            openMonth(){
                this.monthCheck = true
                setTimeout(() => {
                    this.enableMonthCheck = true
                }, 100)
                
            },

            closeModule(){
                let add_student = document.getElementById('module_add_student')

                add_student.addEventListener('click', () =>{

                    if(this.anablePerCheck === true && this.perCheck === true){
                        setTimeout(() => {
                            this.perCheck = false
                            this.anablePerCheck = false
                        }, 100)
                        
                    }
                });

                add_student.addEventListener('click', () =>{
                    if(this.enableCodCheck === true && this.codCheck === true){
                        setTimeout(() => {
                            this.codCheck = false
                            this.enableCodCheck = false
                        }, 100)
                    }
                });

                add_student.addEventListener('click', () =>{
                    if(this.enableRateCheck === true && this.rateCheck === true){
                        setTimeout(() => {
                            this.rateCheck = false
                            this.enableRateCheck = false
                        }, 100)
                    }
                });

                add_student.addEventListener('click', () =>{
                    if(this.enableMonthCheck === true && this.monthCheck === true){
                        setTimeout(() => {
                            this.monthCheck = false
                            this.enableMonthCheck = false
                        }, 100)
                    }
                });
            },
           
            selectPerFunc(per){
                this.selectPeriod = per.text
                this.selectPeriodId = per.id
                this.mount.period = per.time_start
            },
           
            selectCodFunc(cod){
                if(this.codCheck === true){
                    this.selectCod = cod.text
                    this.selectCodId = cod.id
                    this.mount.cod = cod.sum
                    this.mount.codId = cod.id
                }
            },  
          
            selectMonthFunc(month){
                this.selectMonth = month.text
                this.selectMonthId = month.id
                this.mount.month = month.id + 1
            },
           
            selectRateFunc(rat){
                
                this.selectRate = rat.text
                this.selectRateId = rat.id
                this.mount.rate = rat.id
            },

        },
        computed:{
            priceChange(){
                console.log(this.prices, this.mount.period, this.mount.rate, this.mount.month)
                this.prices.forEach((item, i) =>{
                    
                    if(item.time_start === this.mount.period && 
                        item.type_id === this.mount.rate && 
                        this.mount.month !== 0 
                    ){
                        if(this.mount.month === 1){
                            this.mount.price = item.price_one - this.mount.cod
                        }else if(this.mount.month === 4){
                            this.mount.price = item.price - this.mount.cod
                        }else if(this.mount.month === 2){
                            this.mount.price = item.price_one*2 - this.mount.cod
                        }else if(this.mount.month === 3){
                            this.mount.price = item.price_one*3 - this.mount.cod
                        }
                        this.mount.periodId = item.id
                        
                    }
                })

                return this.mount.price
            }
        },
        directives: {
            clickOutside: {
                bind(el, binding) {
                el.addEventListener('click', e => e.stopPropagation());
                document.body.addEventListener('click', binding.value);
                },
                unbind(el, binding) {
                document.body.removeEventListener('click', binding.value);
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
@import "../../../styles_fonts.scss";

    $font_Geometria: Geometria, 'Geometria';

    $color_background: #F6F6FB;
    $color_Gray_1: #C5C5C9;
    $color_Gray_2: #ABABB2;
    $color_Gray_3: #EBEBEB;
    $color_Gray_4:  #F9F9F9;
    $color_Gray_5: #8D909F;
    $color_black: #333333;
    $color_purple: #8C71FE;
    $color_purple_1: #7B61EB;
    $color_purple_2: #6F57D6;
    $color_purple2: #F2F1FF;
    $color_purple3: #E2E2F6;
    $color_purple6: #B1A1F2;
    $color_red: #FF6597;
    $color_white: #FFFFFF;
    $color_cyan: #C0CADC;
    $color_cyan2: #AEBCD6;
    $color_cyan3: #D1DBED;
    $color_green: #89ce54;


.fade-enter-active, .fade-leave-active {
    transition: opacity ease .5s;
}
.fade-enter, .fade-leave-to {
    opacity: 0;
}
.add_student{
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    width: 100%;
    background: rgba(0, 0, 0, 0.39);
    display: flex;
    border: 0;
    align-items: center;
    justify-content: center;
    z-index: 100;
    font-family: $font_Geometria;
}

.add_student_block{
    width: 69%;
    background: #FFFFFF;
    border: 0px solid rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 12px;
}
.add_student_header{
    padding: 24px 40px 22px 40px;
    background: $color_purple;
    border-radius: 12px 12px 0px 0px;
    display: flex;
    align-items:center;
    justify-content: space-between;

}
.title{
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: bold;
    font-size: 22px;
    line-height: 120%;
    color: #FFFFFF;
}
.svg{
    cursor: pointer;
    display: flex;
    align-items: flex-end;
}
.block_add_student{
    padding: 37px 40px 40px 40px;
}
.add_student_main_info{
    display: grid;
    grid-gap: 20px;
}
.stroke2{
    padding: 23px 0px 0px 0px;
    grid-template-columns: 1.08fr 1.08fr 0.816fr 0.816fr;    
}
.stroke1{
    grid-template-columns: 1.08fr 1.08fr 0.55fr 1.08fr ;    
}
.title_block{
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: $color_Gray_1;
    margin-bottom: 5px;
}
.rate{
    width: 100%;
    position: relative;
}
.period{
    width: 100%;
    position: relative;
}
.cod{
    width: 100%;
    position: relative;
}
.month{
    width: 100%;
    position: relative;
}
.block{
    width: 100%;
}
.color_black{
    color: $color_black;
}
.price{
    background: #F2F2F2;
    color: #ABABB2;

}
.disabled{
    transition: all 0.5s;
    color: #ABABB2;
    background: #F2F2F2;
}
.active{
    transition: all 0.5s;
    color: $color_Gray_2;
    background: #FFFFFF;
}
.item{
    cursor: pointer;
    padding: 0px 0px 0px 0px;
    border: 1px solid #E2E2F6;
    box-sizing: border-box;
    border-radius: 6px;
    justify-content: space-between;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 140%;
    display: flex;
    align-items: center;
    
    

    .check{
        cursor: pointer;
        padding: 10px;
        display: flex;
        align-items: flex-end;
        background: $color_background;
        border-radius: 0px 5px 5px 0px;
        transition: 0.5s;
    }
    .check_active{
        transition: 0.5s;
        cursor: pointer;
        padding: 10px;
        display: flex;
        align-items: flex-end;
        background: $color_purple;
        border-radius: 0px 5px 5px 0px;

        svg path{
            stroke: $color_white;
            fill: $color_white;
        }
    }

}

.add_student_button{
    display: flex;
    align-items:center;
    justify-content: flex-end;
    margin-top: 26px;
}
.button{
    background: $color_purple;
    border-radius: 8px;
    padding: 19px 32px 17px 32px;
    font-family: $font_Geometria;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 20px;
    display: flex;
    align-items: center;
    text-align: center;
    color: $color_white;
    outline:0;
    border:0;
    cursor: pointer;
    transition: all 0.5s;

}
.button:hover{
    background: $color_purple_1;
}
.button:active {
    background: $color_purple_2;
}
.block_item_svg{
    display: flex;
    align-items:flex-end;
    padding-right: 9px;
}
.item_block{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 17px 20px 17px 20px;
}
.block_item_module{
    position: absolute;
    top:0;
    left:0;
    max-height: 400px;
    overflow-x: auto;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-sizing: border-box;
    box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
    border-radius: 8px;
    padding: 2px 44px 2px 24px;
     z-index: 20;    

    .block_item_module_text{
        cursor: pointer;
         white-space: nowrap; 
        font-family: $font_Geometria;
        font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 140%;
        color: $color_black;
        padding: 9px 0 9px 0;
        transition: all 0.5s;   
       
    }
    .block_item_module_text:hover{
        color: $color_purple;
    }


}
.block_item_module::-webkit-scrollbar{
    -webkit-appearance: none;
    width: 4px;
    height: 215px;
    padding-right: 6px;
}
.block_item_module::-webkit-scrollbar-thumb{
    border-radius: 3px;
    background-color: $color_cyan;
    padding-right: 6px;
}

   .inputBlock {
       

        .inputBlock_title {
            font-family: $font_Geometria;
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 18px;
            color: $color_Gray_1;
        }

        .inputBlock_input {
            display: flex;
            margin-top: 5px;
            position: relative;
            z-index: 5;

           
            input {
                font-family:  $font_Geometria;
                height: 54px;
                width: 100%;
                border: 1px solid rgba(0, 0, 0, 0.08);
                border-radius: 8px;
                color: $color_black;
                font-size: 16px;
                line-height: 140%;
                display: flex;
                align-items: center;
                padding: 0 0px 0 22px;
                font-weight: 400;
                font-style: normal;
                outline: none;
                transition: 0.5s ease;
            }
          
            input:focus {
                border: 1px solid $color_purple_1;
            }

            .input_logo svg {
                transition: 0.25s ease;
                path {
                    transition: 0.25s ease;
                }
            }

            input:focus + .input_logo svg path {
                fill: $color_purple_1;
            }
            input:hover + .input_logo svg path {
                fill: $color_Gray_2;
            }

            input::-webkit-input-placeholder { /* WebKit, Blink, Edge */
                font-family: $font_Geometria;
                color: $color_Gray_2;
            }
            input:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
                color: $color_Gray_2;
                font-family: $font_Geometria;

                opacity: 1;
            }
            input::-moz-placeholder { /* Mozilla Firefox 19+ */
                color: $color_Gray_2;
                font-family: $font_Geometria;

                opacity: 1;
            }
            input:-ms-input-placeholder { /* Internet Explorer 10-11 */
                color: $color_Gray_2;
                font-family: $font_Geometria;

            }
            input::-ms-input-placeholder { /* Microsoft Edge */
                color: $color_Gray_2;
                font-family: $font_Geometria;

            }

            input::placeholder { /* Most modern browsers support this now. */
                color: $color_Gray_2;
                font-family: $font_Geometria;

            }
            
        }
         .input_logo {
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            right: 24px;
            width: 22px;
            height: 100%;
            cursor: text;
        }
   }
    .notifications {
        display: flex;
        position: absolute;
        z-index: 15;
        top: calc(64px + 10px);
        left: 0;
        width: calc(100% - 40px);
        min-height: calc(100% - 40px);
        background-color: $color_red;
        color: white;
        cursor: default;
        box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1), 0px 4px 4px rgba(0, 0, 0, 0.1);
        border-radius: 12px;
        padding: 20px;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        line-height: 23px;

        .notifications_square {
            position: absolute;
            background-color: $color_red;
            width: 14px;
            height: 14px;
            top: -7px;
            left: 28px;
            transform: rotate(45deg);
        }
    }
</style>